import stepBrowse from '@/assets/landing/first.png.asset.json';
import stepCart from '@/assets/landing/2nd.png.asset.json';
import stepTrack from '@/assets/landing/3rd.png.asset.json';
import { assetUrl } from '@/lib/assetUrl';

const STEPS = [
  {
    n: '1',
    title: 'Browse restaurants near you',
    body: 'Explore nearby restaurants and stores, check menus and prices, and find exactly what you are craving.',
    img: assetUrl(stepBrowse.url),
    alt: 'Browsing restaurants near you in the GAMBGO app',
  },
  {
    n: '2',
    title: 'Add to cart and check out',
    body: 'Pick your meals, customise them how you like, and check out in seconds. The price you see is the price you pay.',
    img: assetUrl(stepCart.url),
    alt: 'Adding items to the cart from a restaurant menu in GAMBGO',
  },
  {
    n: '3',
    title: 'Track your order to your door',
    body: 'Watch your order move in real time, from the kitchen to your location, and call your rider any time.',
    img: assetUrl(stepTrack.url),
    alt: 'Live order tracking with the rider on the map in GAMBGO',
  },
];

export const HowToOrder = () => (
  <section className="bg-background px-4 py-16 sm:py-24">
    <div className="mx-auto max-w-6xl">
      <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-landing-ink sm:mb-20 sm:text-4xl">
        How to order on GAMBGO
      </h2>

      <div className="space-y-16 sm:space-y-28">
        {STEPS.map((step, i) => (
          <div
            key={step.n}
            className={`flex flex-col items-center gap-8 sm:gap-16 ${
              i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'
            }`}
          >
            <div className="flex-1 text-center md:text-left">
              <span className="mb-4 inline-flex h-11 w-11 items-center justify-center rounded-full bg-brand text-lg font-bold text-brand-foreground">
                {step.n}
              </span>
              <h3 className="mb-3 text-2xl font-bold text-landing-ink sm:text-3xl">{step.title}</h3>
              <p className="mx-auto max-w-md text-base leading-relaxed text-muted-foreground md:mx-0 sm:text-lg">
                {step.body}
              </p>
            </div>
            <div className="flex-1">
              <img
                src={step.img}
                alt={step.alt}
                loading="lazy"
                className="mx-auto w-full max-w-[300px] drop-shadow-2xl sm:max-w-[340px]"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
